// This file is auto-generated by Kubb. Do not edit manually.
/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

import { payerSchema } from "./payerSchema.ts";

export const adHocSelfPaySchema = z.object({
  entryPointType: z.enum(["AD_HOC_SELF_PAY"]),
  memberId: z.string(),
  payer: z
    .lazy(() => payerSchema)
    .describe(
      "The workspace's default Medicaid payer used for this enrollment.",
    ),
  state: z.string(),
  type: z.enum(["VANCE_AD_HOC_SELF_PAY"]),
  workspaceId: z.string(),
});
